import student from './student'
import myClassMate from './myClassMate'
import classSchedule from './classSchedule'
import classPhoto from './classPhoto'
import classHomeWork from './classHomeWork'
import classHomeWorkDetails from './classHomeWorkDetails'
import classAnnouncement from './classAnnouncement'
import classAnnouncementDetails from './classAnnouncementDetails'
import comprehensiveEvaluation from './comprehensiveEvaluation'
import classEvaluationDetails from './classEvaluationDetails'
import teacherEvaluationDetails from './teacherEvaluationDetails'
import switchClass from './switchClass'
import classSing from './classSingIn'
import classSignResult from './classSignInResult'
import liveRoom from './liveRoom'
import personalInformation from './personalInformation'
import announcements from './announcements'
import bulletinDetail from './bulletinDetail'
import my from './my'
import certificateView from './certificateView'
import onlineLearning from './onlineLearning'
import apply from './apply'
const studentuser = {
  path: 'studentuser',
  component: resolve => require(['../../../components/pages/student_user'], resolve),
  redirect: 'studentuser/student',
  children: [
    student,
    myClassMate,
    classSchedule,
    classPhoto,
    classHomeWork,
    classHomeWorkDetails,
    classAnnouncement,
    classAnnouncementDetails,
    comprehensiveEvaluation,
    classEvaluationDetails,
    teacherEvaluationDetails,
    classSing,
    switchClass,
    classSignResult,
    liveRoom,
    personalInformation,
    announcements,
    bulletinDetail,
    my,
    certificateView,
    onlineLearning,
    apply
  ]
}
export default studentuser
